import React, {useCallback, useEffect} from "react";
import {Exist, Modal} from "components";
import styled from "styled-components";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as CheckIcon} from "apps/DRAW_PREDICTOR/assets/images/icons/checkBigIcon.svg";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH, trackAdobeAnalytics} from "modules";
import {isLoggedIn} from "modules/selectors";
import {CancelButton, PrimaryButton} from "apps/DRAW_PREDICTOR/components/Buttons";
import {showDrawConfirmation} from "apps/DRAW_PREDICTOR/modules/selectors";
import {IS_PRE_DRAW} from "apps/DRAW_PREDICTOR/modules/constants";

const ModalInner = styled.div`
	text-align: center;
	padding: 20px;

	h2 {
		font-family: "Qatar2022", sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 25px;
		line-height: 120%;
		margin: 30px auto 10px;
		max-width: 460px;
	}

	h3 {
		max-width: 500px;
		font-family: "Graphik";
		font-style: normal;
		font-weight: normal;
		font-size: 18px;
		line-height: 160%;
		margin: 0 auto 20px;
	}
`;

const Buttons = styled.div`
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

export const DrawConfirmationModal: React.FC = () => {
	const dispatch = useDispatch();
	const {t} = useTranslation(LANGUAGE_PATH);
	const isUser = useSelector(isLoggedIn);
	const descKey = isUser
		? "modal.complete.body_copy_logged_in"
		: "modal.complete.body_copy_logged_out";
	const show = useSelector(showDrawConfirmation);

	useEffect(() => {
		if (show) {
			trackAdobeAnalytics({
				section: "",
				eventName: "drawSubmit",
			});
		}
	}, [show]);

	const handleModalClose = useCallback(() => {
		dispatch(handleModalState({drawConfirmation: false}));
	}, [dispatch]);

	const share = useCallback(() => {
		// TODO: add share
		handleModalClose();
	}, [handleModalClose]);

	const login = useCallback(() => {
		// TODO: add login
		handleModalClose();
	}, [handleModalClose]);

	if (!show) {
		return null;
	}

	return (
		<Modal onClose={handleModalClose}>
			<ModalInner>
				<CheckIcon />
				<h2>{t("modal.complete.header_copy")}</h2>
				<h3>{t(descKey)}</h3>

				{isUser ? (
					<Buttons>
						<PrimaryButton onClick={handleModalClose}>
							{t("modal.complete.button_edit")}
						</PrimaryButton>
						<CancelButton onClick={share}>
							{t("modal.complete.button_share")}
						</CancelButton>
					</Buttons>
				) : (
					<Buttons>
						<Exist when={!IS_PRE_DRAW}>
							<PrimaryButton onClick={login}>
								{t("modal.complete.button_login")}
							</PrimaryButton>
						</Exist>
						<CancelButton onClick={handleModalClose}>
							{t("modal.complete.button_edit")}
						</CancelButton>
					</Buttons>
				)}
			</ModalInner>
		</Modal>
	);
};
